<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-login vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col  sm:m-0 m-4">
      <vx-card class="p-2">
        <div slot="no-body" class="full-page-bg-color" >
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col sm:w-full md:w-full  d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">
                <img src="@/assets/images/pages/tacna-logo.png" alt="logo-tacna" class="mx-auto w-4/5">
                <div class="p-10">
                  <login-jwt></login-jwt>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
      <div class="vx-row no-gutter justify-center items-center my-5">
       <router-link to="/forgot-password" class="text-white">Forgot Password?</router-link>
      </div>
      <div class="vx-row no-gutter justify-center items-center pt-20">
        <p>© 2020 TACNA Services, Inc. All Rights Reserved.</p>
      </div>
    </div>
  </div>
</template>


<script>
import LoginJwt from './LoginJWT.vue'

export default {
  components: {
    LoginJwt
  },
  mounted(){
    localStorage.clear()
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 305px;
  border-radius: .286rem;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
